import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import AdCalenderCarousel from '../../../components/organism/AdCalenderCarousel/AdCalenderCarousel';
import { get } from 'lodash';
import useStyles from './style';
import { Box } from '@material-ui/core';
import AdCalendarCarouselType2 from '../../../components/organism/AdCalendarCarouselType2';
import Typography from '../../../components/atoms/Typography';
import Button from '../../../components/atoms/Button';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import Picture from '../../../components/atoms/Picture';
import { getUId } from '../../../../utils/utility';


const createSVG = (type = '', fill = '', customClass = '') => {
  switch (type) {
    case 'cross':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 12 12" fill="none">
          <path d="M2 2L10 10M2 10L10 2" stroke="white" stroke-width="2" stroke-linecap="round" />
        </svg>
      )
    case 'variant2supergraphic1':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1049" height="876" viewBox="0 0 1049 876" fill="none">
          <g opacity="0.4">
            <path d="M673.611 -508.619C616.126 -503.741 552.837 -463.14 504.864 -371.412C640.942 -346.31 731.032 -295.008 854.374 -186.671C905.123 -280.941 830.187 -517.601 673.611 -508.619Z" fill="white" />
            <path d="M991.956 100.575C820.08 -72.5165 677.006 -146.645 525.879 -171.198C281.927 -210.833 49.8513 -66.7037 9.53546 258.985C-30.5996 578.718 51.3815 878.631 534.683 957.151L1924.75 1182.99C2082.01 1208.54 2186.19 1081.05 2214.97 903.891C2210.63 1076.04 2247.72 1235.46 2439.5 1266.62L2694.96 1308.13C2927.41 1345.89 3032.49 1178.89 3072.53 932.47C3105.34 730.525 3164.96 601.03 3319.15 626.082C3714.23 690.27 4109.46 1528.96 4451.84 1592.81C4622.44 1623.52 4731.94 1482.68 4832.17 1345.56L4823.91 1338.23C4787.14 1346.48 4742.11 1347.39 4698.38 1340.29C4384.62 1289.31 3951.12 390.53 3517.68 320.111C3174.77 264.399 3087.72 577.257 3045.55 836.796C3022.69 977.501 2974.41 983.875 2747.34 946.983L2578.57 919.563C2360.7 884.166 2219.3 872.418 2256.05 699.548C2278.12 597.625 2225.61 448.073 2375.05 429.7L2376.35 421.681C2269.44 381.862 2322.89 322.047 2207.41 189.546L2198.97 188.175C2170.32 345.149 2174.85 482.073 2206.13 677.221C2221.31 767.984 2165.84 852.508 1994 824.59L465.082 576.19C182.773 530.324 8.771 462.395 30.3281 329.709C36.132 293.986 54.865 251.384 104.87 219.849C170.934 176.706 298.188 149.49 418.043 162.977C837.033 210.845 993.734 608.202 1325.14 662.045C1398.02 673.886 1457.84 601.294 1544.19 496.344L1539 489.514C1523.47 492.979 1505.83 490.112 1491.25 487.744C1457.5 482.26 1414.96 458.139 1350.6 413.261C1368.91 276.307 1501.86 -222.152 1665.2 -384.184L1666.5 -392.204C1559.58 -432.023 1422.35 -508.195 1306.87 -640.696L1300.74 -641.693L1244.86 -244.452L1244.36 -240.432C1233.63 -154.035 1198.93 125.296 1302.58 379.269C1206.78 309.827 1096.71 202.151 991.956 100.575Z" fill="white" />
          </g>
        </svg>
      )
    case 'variant2supergraphic2':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1600" height="876" viewBox="0 0 1600 876" fill="none">
          <path d="M-319.389 -553.619C-376.874 -548.741 -440.163 -508.14 -488.136 -416.412C-352.058 -391.31 -261.968 -340.008 -138.626 -231.671C-87.8772 -325.941 -162.813 -562.601 -319.389 -553.619Z" fill="#00D8CC" />
          <path d="M-1.04441 55.5753C-172.92 -117.516 -315.994 -191.645 -467.121 -216.198C-711.073 -255.833 -943.149 -111.704 -983.465 213.985C-1023.6 533.718 -941.618 833.631 -458.317 912.151L931.749 1137.99C1089.01 1163.54 1193.19 1036.05 1221.97 858.891C1217.63 1031.04 1254.72 1190.46 1446.5 1221.62L1701.96 1263.13C1934.41 1300.89 2039.49 1133.89 2079.53 887.47C2112.34 685.525 2171.96 556.03 2326.15 581.082C2721.23 645.27 3116.46 1483.96 3458.84 1547.81C3629.44 1578.52 3738.94 1437.68 3839.17 1300.56L3830.91 1293.23C3794.14 1301.48 3749.11 1302.39 3705.38 1295.29C3391.62 1244.31 2958.12 345.53 2524.68 275.111C2181.77 219.399 2094.72 532.257 2052.55 791.796C2029.69 932.501 1981.41 938.875 1754.34 901.983L1585.57 874.563C1367.7 839.166 1226.3 827.418 1263.05 654.548C1285.12 552.625 1232.61 403.073 1382.05 384.7L1383.35 376.681C1276.44 336.862 1329.89 277.047 1214.41 144.546L1205.97 143.175C1177.32 300.149 1181.85 437.073 1213.13 632.221C1228.31 722.984 1172.84 807.508 1001 779.59L-527.918 531.19C-810.227 485.324 -984.229 417.395 -962.672 284.709C-956.868 248.986 -938.135 206.384 -888.13 174.849C-822.066 131.706 -694.812 104.49 -574.957 117.977C-155.967 165.845 0.734174 563.202 332.141 617.045C405.019 628.886 464.845 556.294 551.186 451.344L545.996 444.514C530.473 447.979 512.829 445.112 498.253 442.744C464.498 437.26 421.961 413.139 357.6 368.261C375.913 231.307 508.865 -267.152 672.196 -429.184L673.499 -437.204C566.584 -477.023 429.354 -553.195 313.875 -685.696L307.738 -686.693L251.86 -289.452L251.362 -285.432C240.629 -199.035 205.93 80.2964 309.579 334.269C213.776 264.827 103.711 157.151 -1.04441 55.5753Z" fill="#00D8CC" />
        </svg>
      )
    default:
      return <></>
  }
}


const UpperSectionTabs = [
  {
    "id": "e9fc8be4-13cc-47df-8af0-bd8f6f13e067",
    "fields": {
      "searchKey": {
        "value": ""
      },
      "sortOrder": {
        "value": ""
      },
      "taxonomyKey": {
        "value": "next_7_days"
      },
      "taxonomyValue": {
        "value": "Next 7 Days"
      }
    }
  },
  {
    "id": "3cbb6bd7-e6f2-45fb-bfb6-b643b046a6ce",
    "fields": {
      "searchKey": {
        "value": ""
      },
      "sortOrder": {
        "value": ""
      },
      "taxonomyKey": {
        "value": "next_30_days"
      },
      "taxonomyValue": {
        "value": "Next 30 Days"
      }
    }
  },
  {
    "id": "1066b9d8-5594-4d38-a26a-8017f22b8928",
    "fields": {
      "searchKey": {
        "value": ""
      },
      "sortOrder": {
        "value": ""
      },
      "taxonomyKey": {
        "value": "next_month"
      },
      "taxonomyValue": {
        "value": "Next Month"
      }
    }
  }
]

const cta = {
  "value": {
    "href": "/en/events/calendar",
    "text": "See all",
    "anchor": "",
    "linktype": "internal",
    "class": "",
    "title": "",
    "querystring": "",
    "id": "{272F7348-03E2-423F-BA7C-2F41C1ABB4DD}"
  }
};

const EventsDualCarouselSubLayout = (props) => {
  const uid = getUId(props)
  const classes = useStyles();

  // Update 'upper-section' field when BE updates
  const upperComponent = get(props, 'rendering.placeholders.upper-section[0]', '');
  const upperComponentName = upperComponent.componentName;

  // Update 'lower-section' field when BE updates
  const lowerComponent = get(props, 'rendering.placeholders.lower-section[0]', '');
  const lowerComponentName = lowerComponent.componentName;

  const componentBgColor = get(props, 'rendering.fields.BgColor.fields.colorCode.value', '#9237BA');
  const hasSupergraphicImage = !!get(props, 'rendering.fields.SupergraphicImage.value.src')
  const componentSupergraphicImage = get(props, 'rendering.fields.SupergraphicImage', null);

  const eventsDualCarouselVariant =
    (upperComponentName === 'EventsTabsFilter' && lowerComponentName === 'Top10Events') ? 1 :
      (upperComponentName === 'SmartListSlider' && lowerComponentName === 'SmartListSlider') ? 2 : 3;

  // console.log('hasSupergraphicImage', hasSupergraphicImage);


  return (
    <Box uid={uid} className={
      clsx(classes.EventsDualCarouselSubLayout, eventsDualCarouselVariant && 'eventsDualCarouselVariant-' + eventsDualCarouselVariant)
    }>
      <Box
        className={'bg-wrapper'}
        style={{ backgroundColor: componentBgColor }}
      >
        {hasSupergraphicImage && <Picture media={{ image: componentSupergraphicImage }} />}
      </Box>
      <Placeholder name="upper-section" rendering={props.rendering} appConfig={props.appConfig} />
      <Placeholder name="lower-section" rendering={props.rendering} appConfig={props.appConfig} />
    </Box>
  );
};

export default EventsDualCarouselSubLayout;
